import { MqlCompiledQuery, MqlScope } from '@deqo/mql-js';

export const EmptyMqlCompiledQuery: MqlCompiledQuery = Object.freeze({
    source: '',
    test<T>(_scope: MqlScope, _item: T) {
        return false;
    },
    filter<T>(_scope: MqlScope, _items: T[]): T[] {
        return [];
    }
});
